


















import { Component, Vue } from 'vue-property-decorator';

import Presenters from '@/components/Fourth/presenters/Presenters.vue';
import Program from '@/components/Fourth/program/Program.vue';
import Contributors from '@/components/Fourth/contributors/Contributors.vue';
import Directions from '@/components/Fourth/directions/Directions.vue';

@Component({
  components: {
    Presenters,
    Program,
    Contributors,
    Directions
  }
})
export default class Main extends Vue {}
